module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAHCAYAAAGkd/eMAAAAAXNSR0IArs4c6QAAAMlJREFUGBlj9PMLvf7x40cNRnt7t/8CAoJXGf7//+8L4oAwiA2WYYABmCxY5ufPn/5ubr4bYJIweteuzQGMIBUwAXd334U7d26Oh/FRzYSJAmkmOTmZ/Uh8MFNWVmYf88WL594dPXqC6927dxogUTU1lY3z58+cDrenqKgikJGR4X9vbwfYQYwxMUl7Hz9+4oRuHC6+jIz0frhpCQmpWQ8ePPLApVhRUWEH0PppIHm4Jpji7OzCmKtXr4XB+NraWqumTu1fAuODaACLll8w1ic4DwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/arrw.png
// module id = 71xv
// module chunks = 0